import { z } from 'zod'

import { idSchema, msTimestampSchema } from './common.ts'

export const AgentOutputActionEnum = z.enum(['publish', 'hold', 'skip', 'system_error'])
export type AgentOutputAction = z.infer<typeof AgentOutputActionEnum>

export const AgentDecisionSchema = z.object({
  id: idSchema,
  workspaceId: idSchema,
  // Null when the tick skipped before resolving an active campaign.
  campaignId: idSchema.nullable().default(null),
  ranAt: msTimestampSchema,
  durationMs: z.number().nonnegative(),
  inputSnapshot: z.record(z.string(), z.unknown()),
  outputAction: AgentOutputActionEnum,
  outputPayload: z.record(z.string(), z.unknown())
})

export type AgentDecisionRow = z.infer<typeof AgentDecisionSchema>
